import React from 'react';
import styled from 'styled-components';

import Icon from 'components/Icon';

const StatusWrapper = styled.div`
  height: 11vh;
  max-height: 11vh;
  min-height: 9vh;
  position: relative;
  z-index: 99;
  width: 100%;
  background-color: ${props => props.bgColor};
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.stripped === true ? `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-image : linear-gradient(
        45deg,
        rgba(255, 255, 255, .1)
        25%, transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, .1) 50%,
        rgba(255, 255, 255, .1) 75%,
        transparent 75%, transparent
      );
      z-index: 1;
      background-size: 1.6vw 1.6vw;
      overflow: hidden;
    }
  ` : null}
`;

const StatusMessage = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  font-size: 4.4vh;
`;

const StatusBar = ({ isMaintenance, isAnomaly, message }) => {
  let style = {};
  if (isMaintenance) {
    style = {
      color: '#232526',
      bgColor: '#FAAD14',
      icon: 'alert-triangle',
    };
  } else if (isAnomaly) {
    style = {
      color: '#ffffff',
      bgColor: '#44494c',
      icon: 'alert-circle',
      stripped: true,
    };
  } else {
    style = {
      color: '#ffffff',
      bgColor: '#104663',
      icon: 'clock',
    };
  }

  return (
    <StatusWrapper bgColor={style.bgColor} stripped={style.stripped}>
      <Icon
        name={style.icon}
        size={'5vh'}
        color={style.color}
        strokeWidth={2.5}
        style={{
          marginRight: '2vh',
        }}
      />
      <StatusMessage style={{ color: style.color }}>
        {message}
      </StatusMessage>
    </StatusWrapper>
  );
};


export default StatusBar;